module.exports = __webpack_public_path__ + "static/media/arrowIcon.8150eb01.svg";